/**
 * NativeWaves Content API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class ProgramsApi extends runtime.BaseAPI {
    /**
     * Get programs in bulk.
     */
    async programsV2BatchGetPostRaw(requestParameters, initOverrides) {
        if (requestParameters.expManifestBatchGet === null ||
            requestParameters.expManifestBatchGet === undefined) {
            throw new runtime.RequiredError('expManifestBatchGet', 'Required parameter requestParameters.expManifestBatchGet was null or undefined when calling programsV2BatchGetPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/programs/v2/$batchGet`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.expManifestBatchGet,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get programs in bulk.
     */
    async programsV2BatchGetPost(requestParameters, initOverrides) {
        const response = await this.programsV2BatchGetPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of programs. If the filter: \'query\' is used, then the max total return count is limited to 10 000 even with pagination.
     */
    async programsV2GetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.environmentId !== undefined) {
            queryParameters['environmentId'] = requestParameters.environmentId;
        }
        if (requestParameters.repositoryId !== undefined) {
            queryParameters['repositoryId'] = requestParameters.repositoryId;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.view !== undefined) {
            queryParameters['view'] = requestParameters.view;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.groups) {
            queryParameters['groups'] = requestParameters.groups;
        }
        if (requestParameters.excludeGrouped !== undefined) {
            queryParameters['excludeGrouped'] = requestParameters.excludeGrouped;
        }
        if (requestParameters.locale !== undefined) {
            queryParameters['locale'] = requestParameters.locale;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/programs/v2`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of programs. If the filter: \'query\' is used, then the max total return count is limited to 10 000 even with pagination.
     */
    async programsV2Get(requestParameters = {}, initOverrides) {
        const response = await this.programsV2GetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new program.
     */
    async programsV2PostRaw(requestParameters, initOverrides) {
        if (requestParameters.expManifestInsert === null ||
            requestParameters.expManifestInsert === undefined) {
            throw new runtime.RequiredError('expManifestInsert', 'Required parameter requestParameters.expManifestInsert was null or undefined when calling programsV2Post.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/programs/v2`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.expManifestInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new program.
     */
    async programsV2Post(requestParameters, initOverrides) {
        const response = await this.programsV2PostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a program.
     */
    async programsV2ProgramIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.programId === null ||
            requestParameters.programId === undefined) {
            throw new runtime.RequiredError('programId', 'Required parameter requestParameters.programId was null or undefined when calling programsV2ProgramIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/programs/v2/{programId}`.replace(`{${'programId'}}`, String(requestParameters.programId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a program.
     */
    async programsV2ProgramIdDelete(requestParameters, initOverrides) {
        await this.programsV2ProgramIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a program.
     */
    async programsV2ProgramIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.programId === null ||
            requestParameters.programId === undefined) {
            throw new runtime.RequiredError('programId', 'Required parameter requestParameters.programId was null or undefined when calling programsV2ProgramIdGet.');
        }
        const queryParameters = {};
        if (requestParameters.view !== undefined) {
            queryParameters['view'] = requestParameters.view;
        }
        if (requestParameters.locale !== undefined) {
            queryParameters['locale'] = requestParameters.locale;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/programs/v2/{programId}`.replace(`{${'programId'}}`, String(requestParameters.programId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a program.
     */
    async programsV2ProgramIdGet(requestParameters, initOverrides) {
        const response = await this.programsV2ProgramIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a program.
     */
    async programsV2ProgramIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.programId === null ||
            requestParameters.programId === undefined) {
            throw new runtime.RequiredError('programId', 'Required parameter requestParameters.programId was null or undefined when calling programsV2ProgramIdPatch.');
        }
        if (requestParameters.expManifestEdit === null ||
            requestParameters.expManifestEdit === undefined) {
            throw new runtime.RequiredError('expManifestEdit', 'Required parameter requestParameters.expManifestEdit was null or undefined when calling programsV2ProgramIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/programs/v2/{programId}`.replace(`{${'programId'}}`, String(requestParameters.programId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.expManifestEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a program.
     */
    async programsV2ProgramIdPatch(requestParameters, initOverrides) {
        const response = await this.programsV2ProgramIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const ProgramsV2GetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
/**
 * @export
 */
export const ProgramsV2GetViewEnum = {
    Slim: 'Slim',
    Full: 'Full',
};
/**
 * @export
 */
export const ProgramsV2ProgramIdGetViewEnum = {
    Slim: 'Slim',
    Full: 'Full',
};
//# sourceMappingURL=ProgramsApi.js.map